import _get from 'lodash/get';
import React, { useCallback } from 'react';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';
import { NewBookingDeliveryPropType } from 'common/prop-types';
import NumberedPin from 'components/v2/common/numbered-pin';
import InsuranceOptions from 'components/v2/insurance/insurance-options';
import {
  getInsuranceOptionID,
  getSelectedInsuranceOption,
} from 'helper/insurance';
import styles from './delivery-guarantee.less';
import sectionStyles from '../anytime-booking/overlay/common-section-ui/styles.less';

const MSDDeliveryGuarantee = ({
  onChange,
  delivery,
  deliveriesInsuranceDetails,
}) => {
  const options = _get(delivery, 'quote.insurance.options');
  const dropOffDeliveryGuaranteeChange = useCallback(
    dropOff => insuranceOptionID => onChange(insuranceOptionID, dropOff),
    [onChange],
  );
  const {
    allSameOption,
    dropOffIndexWithHighestInsuranceOption,
  } = deliveriesInsuranceDetails;
  return (
    <div className={sectionStyles.section}>
      {delivery.detail.dropOffs.map((dropOff, index) => (
        <div className={styles.stepDeliveryGuarantee} key={dropOff}>
          <div className={styles.pinWrap}>
            <NumberedPin
              className={styles.pin}
              showNumber
              number={`${index + 1}`}
            />
          </div>
          <div className={styles.details}>
            <p className={styles.name}> {_get(dropOff, 'poi.address.name')} </p>
            <p className={styles.address}>
              {_get(dropOff, 'poi.address.combined_address')}
            </p>
            <InsuranceOptions
              selectedInsuranceOptionID={getInsuranceOptionID(
                getSelectedInsuranceOption(delivery)(dropOff),
              )}
              onChange={dropOffDeliveryGuaranteeChange(dropOff)}
              options={options}
            />
            {!allSameOption &&
              index === dropOffIndexWithHighestInsuranceOption && (
                <a
                  onClick={() =>
                    dropOffDeliveryGuaranteeChange(undefined)(
                      getInsuranceOptionID(dropOff.insuranceOption),
                    )
                  }
                  className={styles.applyForAll}
                >
                  {I18n.t('v2.anytimeBooking.insurance.applyAllRecipients')}
                </a>
              )}
          </div>
        </div>
      ))}
    </div>
  );
};

MSDDeliveryGuarantee.propTypes = {
  onChange: PropTypes.func.isRequired,
  delivery: NewBookingDeliveryPropType.isRequired,
  deliveriesInsuranceDetails: PropTypes.shape({}).isRequired,
};

export default MSDDeliveryGuarantee;
